export const API_URL = 'https://kiosk-admin.triniteq.com/api/v1/';
export const BASE_URL = window.location.origin;
// export const API_URL = 'http://admin.liverpool.test/api/v1/';
// export const API_URL = 'http://localhost/posdisneycafe/public/api/v1/';
export const USERNAME = 'Trinited';
export const PASSWORD = 'trinitequbIVPGW!@:Mv%iH';
